import { put, call, takeLatest } from 'redux-saga/effects';
import {
    setLocalStorage,
    rmLocalStorage,
    ACCESS_TOKEN,
    REFRESH_TOKEN,
} from '../../consts/localStorage';
import {
    SIGN_IN_START,
    SIGN_IN_COMPLETE,
    ASSOCIATE_NAME_LIST,
    PAYPLAN_LIST_START,
    TERM_LIST_START,
    LOGOUT_START,
    LOGOUT_COMPLETE,
} from '../../consts/actionTypes';
import { isLoadingAction, snackBarAction } from '../actions/utilitiesAction';
import { associateListByType } from '../actions/associateAction';

import { authCall, apiCall } from '../api';
import { AUTH, ASSOCIATE_LIST_DROP_DOWN } from '../../consts/urls';

export function* signIn({ payload }) {
    try {
        let configHeaders = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const results = yield call(authCall, AUTH, payload, configHeaders, 'POST');
        yield put({ type: SIGN_IN_COMPLETE, results });
        yield setLocalStorage(ACCESS_TOKEN, results.data.access_token);
        yield setLocalStorage(REFRESH_TOKEN, results.data.refresh_token);

        // I don't why what's this
        const associateNameList = yield call(
            apiCall,
            ASSOCIATE_LIST_DROP_DOWN,
            null,
            results.data.access_token,
            'GET'
        );
        yield put({ type: ASSOCIATE_NAME_LIST, associateNameList });
    } catch (error) {
        const messageError = error.response.data.error;
        yield put(
            snackBarAction({
                open: true,
                msg: messageError,
                type: 'error',
            })
        );
    }
    yield put(isLoadingAction(false));
}

function* signOut() {
    yield rmLocalStorage(ACCESS_TOKEN);
    yield rmLocalStorage(REFRESH_TOKEN);
    yield put({ type: LOGOUT_COMPLETE });
}

export default function* authUser() {
    yield takeLatest(SIGN_IN_START, signIn);
    yield takeLatest(LOGOUT_START, signOut);
}
